import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'
import userManageOperations from '../../../../../../redux/UserManagement/operations'
import AddApplicationPermission from "./AddApplicationPermission";
import { SetActiveAppArea } from "redux/UserManagement/action";

const AddApplicationPermissionContainer = ({
  handleChange,
  formError,
  form,
  applicationDropDown,
  setForm
}: any) => {
  const dispatch = useDispatch();
  const dispatchGetActiveAppArea = userManageOperations.dispatchGetActiveAppArea(dispatch)

  const { appPermissionById, appAreaDropDownVal }: any = useSelector((state: any) => ({
    appPermissionById: userManageSelectors.appPermissionById(state),
    appAreaDropDownVal: state.UserManagement.activeAppAreaData,
  }))

  useEffect(() => {
    if (appPermissionById) {
      setForm({
        ...form, nameVal: appPermissionById.permissionName,
        appArea: { key: appPermissionById?.appAreaId?.toString(), value: appPermissionById.appAreaId?.toString() },
        appName: { key: appPermissionById?.applicationID?.toString(), value: appPermissionById.applicationID?.toString() },
        permissionDesc: appPermissionById.permissionDescription
      })
    }
  }, [appPermissionById?.id])

  useEffect(() => {
    if (form.appName.key != null) {
      dispatchGetActiveAppArea(form?.appName?.key)
    } else {
      dispatch(SetActiveAppArea([]))
    }
  }, [form?.appName])
  return (
    <AddApplicationPermission
      handleChange={handleChange}
      formError={formError}
      form={form}
      applicationDropDown={applicationDropDown}
      appAreaDropDownVal={appAreaDropDownVal}
    />
  )
}

export default AddApplicationPermissionContainer;